import WaveSurfer from 'wavesurfer.js';
import { RegionParams, Region } from 'wavesurfer.js/src/plugin/regions';
import { getClipTransition } from 'components/app/_helpers/_app.helper';
import { MIN_REGION_DUR } from 'constants/params';

export type SetRegionsParams = {
  ws: WaveSurfer;
  markers: MarkerId[];
  ranges: EditorTime[];
  transitionTime: Milliseconds;
  draggable?: boolean;
  dragCondition?: (regionID: number) => boolean;
};

const regionCreator = (id: number, startTime: number, transitionTime: number, draggable?: boolean): RegionParams => ({
  id: `${id}`,
  start: startTime,
  end: startTime + transitionTime,
  drag: draggable,
  resize: false,
});

export const setRegions = ({ ws, markers, ranges, transitionTime, dragCondition, draggable }: SetRegionsParams) => {
  ws.clearRegions();
  markers.forEach((marker, index) => {
    const transition = getClipTransition(
      ranges[index + 1],
      transitionTime <= MIN_REGION_DUR ? MIN_REGION_DUR : transitionTime
    );
    const shouldBeDraggable = dragCondition ? dragCondition(index) : draggable;
    ws.addRegion(regionCreator(index, marker, transition, shouldBeDraggable));
  });
};

export const getMarkerNodes = (ws: WaveSurfer) => {
  return Array.from(ws.drawer.wrapper?.children ?? []).filter((el) => (el as HTMLElement).dataset.id) as HTMLElement[];
};

export const isRegionIn = (region: Region, cursorCell: CursorCell) => {
  const cell = Number(region.id) + 1;
  return cursorCell !== cell ? cell : 0;
};
